/* eslint-disable import/no-anonymous-default-export */
import { AutoComplete, Form } from "antd";
import debounce from "lodash.debounce";
import { useMemo, useState } from "react";
import { ActionResult } from "../../common/hooks/useApi";
import useTitularesVehiculoAPI from "../useTitularesVehiculoAPI";



type InputProvinciaProps = {
    type: 'PROVINCIA' | 'DEPARTAMENTO' | 'LOCALIDAD'
    onChange?: (value: any) => void
    onSelect?: (value: any) => void
    onInputKeyDown?: (value: any) => void
    placeholder?: string
    value?: any
    provinciaField?: string
    departamentoField?: string
}
export default (props: InputProvinciaProps) => {
    const [response, setResponse] = useState<ActionResult<any[]>>();
    const titularesVehiculoApi = useTitularesVehiculoAPI();
    const form = Form.useFormInstance();


    const searchProvincias = (value: string) => {
        /*if (!value) {
            setProvinciasResponse(undefined);
            return;
        }*/

        const $apply = [`filter(contains(Provincia,toupper('${value}')))`, `groupby((Provincia))`];
        titularesVehiculoApi
            .queryLocalidades({
                $orderby: ["Provincia asc"],
                $apply
            })
            .then(setResponse);
    };

    const searchDepartamentos = (value: string) => {
        /*
        if (!value) {
            setDepartamentosResponse(undefined);
            return;
        }*/
        const $apply = [
            `filter(Provincia eq '${form.getFieldValue(props.provinciaField!)}' and startswith(Departamento,toupper('${value}')))`,
            `groupby((Departamento))`];

        if (!form.getFieldValue(props.provinciaField!)) {
            $apply[0] = `filter(startswith(Departamento,toupper('${value}')))`;
        }

        /*
        const $apply = [
            `filter(contains(Departamento,toupper('${value}')))`,
            `groupby((Departamento))`];*/
        titularesVehiculoApi
            .queryLocalidades({
                $orderby: ["Departamento asc"],
                $apply
            })
            .then(setResponse);
    };

    const searchLocalidades = (value: string) => {
        /*if (!value) {
            setLocalidadesResponse(undefined);
            return;
        }*/

        titularesVehiculoApi
            .queryLocalidades({
                $orderby: ['Nombre asc'],
                $filter: [
                    props.provinciaField && form.getFieldValue(props.provinciaField) ? `Provincia eq '${form.getFieldValue(props.provinciaField)}'` : '',
                    props.departamentoField && form.getFieldValue(props.departamentoField) ? `Departamento eq '${form.getFieldValue(props.departamentoField)}'` : '',
                    `contains(Nombre,toupper('${value}'))`
                ].filter(f => f != '')
            })
            .then(setResponse);
    };

    const search = async (value: string) => {
        switch (props.type) {
            case 'PROVINCIA':
                await searchProvincias(value);
                break;
            case 'DEPARTAMENTO':
                await searchDepartamentos(value);
                break;
            default:
                await searchLocalidades(value);
                break;
        }
    };


    const getLabelKey = () => {
        switch (props.type) {
            case 'PROVINCIA':
                return "Provincia"
                break;
            case 'DEPARTAMENTO':
                return "Departamento";
                break;
            default:
                return "nombre";
                break;
        }
    }

    //debounce(search, 500, {leading:false,trailing:true})
    return (
        <>
            <AutoComplete
                onChange={(value) => {
                    props.onChange?.(value);
                }}
                value={props.value}
                onSearch={useMemo(() => debounce(search, 500, { leading: false, trailing: true }), [])}
                onSelect={(value: any) => {
                    props.onSelect?.(value);
                    search(value);
                }}
                placeholder={props.placeholder} >
                {response?.data?.value?.map((p, index) =>
                    (<AutoComplete.Option key={index} value={p[getLabelKey()]}>{p[getLabelKey()]}</AutoComplete.Option>))}
            </AutoComplete>
        </>
    );
};